import { toast } from 'sonner';

type AppNotifyOpts = {
    type: 'success' | 'error' | 'info' | 'warning';
    text: string;
    duration?: number;
    position?: 'top-center' | 'top-right' | 'top-left' | 'bottom-center' | 'bottom-right' | 'bottom-left';
};

export const appNotify = ({ type, text, duration = 2000, position = 'top-center' }: AppNotifyOpts) => {
    toast[type](text, {
        duration,
        position,
    });
};
